export default "__VITE_ASSET__bbff63c7__"